import React from "react";

export const L10nContext: React.Context<{}> = React.createContext({});
